export default __webpack_public_path__ + "static/media/046-hot chocolate.c0c78e70.svg";